module.exports = __webpack_public_path__ + "img/dashboard-pe.13219eab.png";